// extracted by mini-css-extract-plugin
export default {"empty":"ResultsError_empty__IyfvY","emptyTitle":"ResultsError_emptyTitle__EGfGB","emptyDescription":"ResultsError_emptyDescription__u02Vc"};